import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 1102 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1102 1024\" id=\"icon-file\"><path d=\"M78.769231 0h945.230769a78.769231 78.769231 0 0 1 78.769231 78.769231v78.769231H0V78.769231a78.769231 78.769231 0 0 1 78.769231-78.769231zM0 236.307692v708.923077a78.769231 78.769231 0 0 0 78.769231 78.769231h945.230769a78.769231 78.769231 0 0 0 78.769231-78.769231V236.307692z m787.692308 157.538462H315.076923V315.076923h472.615385z\" p-id=\"4077\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file.svg
// module id = fQ0v
// module chunks = 80